import React from 'react'

import { isUsingStorageFallback } from '@/lib/browserStorage'
import { changeLanguage } from '@/lib/i18n/locale-utils'
import { getCurrentLocale } from '@/lib/i18n/locale-utils'
import { useAsyncDispatch, useUser } from '@/lib/react-hooks/generic-hooks'
import { AdminUsersActions } from '@/redux/actions'
import { Locales } from '@/types/locale'

import { useLoadLanguages } from '../InvoiceProfile/OnboardingInvoiceProfile/useLoadLanguages'

export function useLanguageSwitcher() {
	const { data: countryLanguages } = useLoadLanguages()
	const locales = React.useMemo(
		() => (countryLanguages ?? []).map((language) => language.code).slice(),
		[countryLanguages],
	)

	const my = useUser()
	const asyncDispatch = useAsyncDispatch()

	const [locale, setLocale] = React.useState(my?.language_code ?? getCurrentLocale())

	const userExists = !!my

	const updateLanguage = async (language: Locales) => {
		await changeLanguage(language)
		await asyncDispatch(AdminUsersActions.updateUserLanguage, language)
	}

	const passOnChange = () => {
		if (!isUsingStorageFallback()) {
			window.location.reload()
		}
	}

	const onChange: (newLocale: Locales) => void = (newLocale) => {
		setLocale(newLocale)

		if (userExists && newLocale !== locale) {
			updateLanguage(newLocale).then(passOnChange)
		} else {
			passOnChange()
		}
	}

	return {
		onChange,
		locale,
		countryLanguages: locales,
	}
}
